
export const validEmail = new RegExp('^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+\.+[a-zA-Z]{2,3}$');

export const changeNumbers=(price)=>{
    var st= price.toString();
    var array =st.split("");
    array.forEach((element,index) => {
        if(element==='0'){
            array[index]='۰';
        }
        else if(element==='1'){
            array[index]='۱';
        }
        else if(element==='2'){
            array[index]='۲';
        }
        else if(element==='3'){
            array[index]='۳';
        }
        else if(element==='4'){
            array[index]='۴';
        }
        else if(element==='5'){
            array[index]='۵';
        }
        else if(element==='6'){
            array[index]='۶';
        }
        else if(element==='7'){
            array[index]='۷';
        }
        else if(element==='8'){
            array[index]='۸';
        }
        else if(element==='9'){
            array[index]='۹';
        }
    });

    return array.join("");
}

export const changeNumbersToEnglish=(price)=>{
    var st= price.toString();
    var array =st.split("");
    array.forEach((element,index) => {
        if(element==='۰'){
            array[index]='0';
        }
        else if(element==='۱'){
            array[index]='1';
        }
        else if(element==='۲'){
            array[index]='2';
        }
        else if(element==='۳'){
            array[index]='3';
        }
        else if(element==='۴'){
            array[index]='4';
        }
        else if(element==='۵'){
            array[index]='5';
        }
        else if(element==='۶'){
            array[index]='6';
        }
        else if(element==='۷'){
            array[index]='7';
        }
        else if(element==='۸'){
            array[index]='8';
        }
        else if(element==='۹'){
            array[index]='9';
        }
    });

    return array.join("");
}

 